<script setup lang="ts">
import { useFlowEditorContext } from '../../composables/useFlowEditor'

/** Display options of the embedded preview player. */
const { visualDisableShadow } = useFlowEditorContext().ui
</script>

<template>
  <div class="flow-settings__panel">
    <h3 class="flow-subtitle">{{ $t('flow.previewDisplay') }}</h3>
    <label class="flow-settings__checkbox-label">
      <input
        type="checkbox"
        :checked="visualDisableShadow"
        @change="visualDisableShadow = ($event.target as HTMLInputElement).checked"
      />
      <span>{{ $t('flow.disableCardShadows') }}</span>
    </label>
    <p class="flow-settings__meta">
      {{ $t('flow.shadowsDesc') }}
    </p>
  </div>
</template>

<style scoped src="../styles/inspectorForm.css"></style>
